import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {SiteProviderModel} from "../../models/site-provider.model";
import {
  SITE_PROVIDERS_TABLE_COLUMN_WIDTHS,
  SITE_PROVIDERS_TABLE_ROW_HEIGHT,
  SITE_PROVIDERS_TABLE_UNIQUE_ID
} from "../../constants/site-providers-table.constant";

require('./site-providers-table.scss');
@Component({
  standalone: false,
  selector: 'app-site-providers-table',
  templateUrl: './site-providers-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteProvidersTableComponent {

  @Input() providers: SiteProviderModel[] = [];
  @Input() isLoading: boolean;

  @Output() onEdit = new EventEmitter<SiteProviderModel>();
  @Output() onArchive = new EventEmitter<SiteProviderModel>();
  @Output() onActiveChange = new EventEmitter<{ provider: SiteProviderModel, active: boolean }>();

  public readonly tableUniqueId: string = SITE_PROVIDERS_TABLE_UNIQUE_ID;
  public readonly defaultWidths: { [key: string]: number } = SITE_PROVIDERS_TABLE_COLUMN_WIDTHS;
  public readonly rowHeight: number = SITE_PROVIDERS_TABLE_ROW_HEIGHT;

}
